import { RESET_TOGGLE_SCHOOL_EDITING } from "../../../constants/SchoolConstants";

export default function resetToggleSchoolEditingAction() {
    return {
        type: RESET_TOGGLE_SCHOOL_EDITING
    };
}
